<div class="seller-confirmation-popup">

    <!-- Close -->
    <div class="ipm-close-icon" (click)="onClose()">
        <i class="pi pi-times"></i>
    </div>

    <!-- Agreement content only — no checkbox rendered inside -->
    <ipm-seller-agreement [isShowSellerArtist]="false"></ipm-seller-agreement>

    <!-- Footer: always pinned outside the scroll area -->
    <div class="scp-footer">
        <div class="checkout-flow">
            <mat-checkbox [(ngModel)]="isAccepted">
                I hereby state that I have read and agree to the <strong>Seller Agreement</strong>.
            </mat-checkbox>
        </div>
        <div class="scp-actions">
            <button
                mat-flat-button
                color="primary"
                class="primary-button scp-submit-btn"
                [disabled]="!isAccepted"
                (click)="onSubmit()">
                Submit &amp; Agree
            </button>
        </div>
    </div>

</div>
